
document.addEventListener("DOMContentLoaded", function(event) {

    const navToggle = document.querySelector('#site-nav-toggle');
    navToggle.addEventListener("click", toggleNav );

});

function toggleNav() {

    const nav = document.querySelector('#site-nav');
    const navToggle = document.querySelector('#site-nav-toggle');
    const body = document.querySelector('body');

    body.classList.toggle('overlay--open');
    nav.classList.toggle('nav-hidden');
    navToggle.classList.toggle('is-active');

    /* if ( nav.classList.contains('hidden') ) {

        // showing now
        nav.classList.add('showing');

        window.setTimeout( () => {
            nav.classList.remove('hidden');

            nav.classList.remove('showing');
            nav.classList.add('shown');

        }, 500);


    } else if ( nav.classList.contains('shown') ) {

        // hiding now
        nav.classList.add('hiding');

        window.setTimeout( () => {

            nav.classList.remove('shown');

            nav.classList.remove('hiding');
            nav.classList.add('hidden');

        }, 500);

    } */

}


jQuery(function($) {
  $(document).ready(function() {
    $('.site-nav__menu a').on('click', function(e) {

      if(this.hash && $(this).attr('href').split('#')[0] == window.location.href ) {
        var target = $(this.hash);
        $('#site-nav-toggle').click();
        e.stopPropagation();
        e.preventDefault();

      if(target) {
        // setTimeout(function() {
        //   $('html, body').animate({
        //     scrollTop: target.offset().top
        //   })
        // }, 300)
      }
      }
    })
  })
})
